function OptionIcon({ children, className = 'h-4 w-4' }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

function IconTaxi(props) {
  return (
    <OptionIcon {...props}>
      <path d="M5 16.5V11l1.6-4.2A2 2 0 0 1 8.5 5.5h7a2 2 0 0 1 1.9 1.3L19 11v5.5" />
      <path d="M5 16.5h14" />
      <circle cx="7.5" cy="16.5" r="1.5" />
      <circle cx="16.5" cy="16.5" r="1.5" />
      <path d="M7 9.5h10" />
    </OptionIcon>
  );
}

function IconBike(props) {
  return (
    <OptionIcon {...props}>
      <circle cx="6" cy="17" r="3" />
      <circle cx="18" cy="17" r="3" />
      <path d="M6 17l4-8h4l3 5" />
      <path d="M10 9h4" />
      <path d="M13 14h5" />
    </OptionIcon>
  );
}

function IconGlobe(props) {
  return (
    <OptionIcon {...props}>
      <circle cx="12" cy="12" r="8" />
      <path d="M4 12h16" />
      <path d="M12 4c2.5 2.2 2.5 13.8 0 16" />
      <path d="M12 4c-2.5 2.2-2.5 13.8 0 16" />
    </OptionIcon>
  );
}

function IconMapPin(props) {
  return (
    <OptionIcon {...props}>
      <path d="M12 21s-6.5-5.9-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.1-6.5 11-6.5 11z" />
      <circle cx="12" cy="10" r="2.2" />
    </OptionIcon>
  );
}

function IconIdCard(props) {
  return (
    <OptionIcon {...props}>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
      <circle cx="8.5" cy="11" r="1.8" />
      <path d="M6 15.3c.4-1.3 1.3-2 2.5-2s2.1.7 2.5 2" />
      <path d="M13.5 9.5h4" />
      <path d="M13.5 13h4" />
    </OptionIcon>
  );
}

function IconHome(props) {
  return (
    <OptionIcon {...props}>
      <path d="M4 11.5L12 4l8 7.5" />
      <path d="M6 10v9.5h12V10" />
      <path d="M10 19.5v-5h4v5" />
    </OptionIcon>
  );
}

export const VEHICLE_OPTIONS = [
  { value: 'taxi', label: 'Taxi', icon: IconTaxi },
  { value: 'bike', label: 'Bike', icon: IconBike },
];
export const LOCATION_OPTIONS = [
  { value: 'outside_uae', label: 'Outside UAE', icon: IconGlobe },
  { value: 'inside_uae', label: 'Inside UAE', icon: IconMapPin },
];
export const LICENSE_OPTIONS = [
  { value: 'uae', label: 'UAE License', icon: IconIdCard },
  { value: 'gcc_home', label: 'HC License', icon: IconHome },
];

export function OptionCards({ options, value, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {options.map((opt) => {
        const Icon = opt.icon;
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={active}
            className={`group relative flex items-center gap-2 rounded-lg border px-3 py-2 text-left transition-all duration-150 ${
              active
                ? 'border-primary bg-primary-50 shadow-sm ring-1 ring-primary/30'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
            }`}
          >
            {Icon && (
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                  active ? 'bg-primary text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-gray-200'
                }`}
              >
                <Icon className="h-3 w-3" />
              </span>
            )}
            <span className={`text-xs font-medium ${active ? 'text-primary' : 'text-gray-700'}`}>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
